<!-- MFITTの払い戻し完了ダイアログ -->
<template>
  <ItemDialog ref="refundCompleted" image-type="done">
    <template #content-area>
      <h2>払いもどしが完了しました</h2>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogRefundCompleted",
  props: {
    closeButtonClicked: {
      type: Function,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const refundCompleted = ref(null);

    const openDialog = () => {
      refundCompleted.value.open();
    };

    const closeDialog = () => {
      if (props.closeButtonClicked == null) {
        refundCompleted.value.close();
      } else {
        props.closeButtonClicked();
      }
    };

    return {
      refundCompleted,
      openDialog,
      closeDialog,
    };
  },
};
</script>
